
import React, { useEffect, useState } from 'react';
import Header from '../sharedFiles/header/header';
import Footer from '../sharedFiles/footer/footer';
import "./ReportsStatement.css";
import { TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch, useSelector } from 'react-redux';
import { getAllReport, getReportData, getReportId } from '../APIServices/LedgerService/ledgerThunk';
import LedgerFormFields from './LedgerFormFields';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import DynamicTable from '../sharedFiles/commonTable/dynamicTable';
import { errorShowing } from '../itemPage/ItemPageShared/ItemUtils';
import SpinnerLoader from '../sharedFiles/loader/spinnerLoader';
import { toast, ToastContainer } from "react-toastify";
const Reports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, GetReport, GetReportfield, GetReportData } = useSelector((state) => state.LedgerReport);
  const [errors, setErrors] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [formData, setFormData] = useState({});
  const [filteredReports, setFilteredReports] = useState([]);
  const [getreportId, setGetReportId] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [showViewButton,setShowViewButton]=useState();
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const [callInProgress, setCallInProgress] = useState(
    {
        fetchInputData: false,
        fetchformFields: false,
        fetchReportData: false,
    });
  useEffect(() => {
    if(GetReport){
      setFilteredReports(GetReport)
    }
  }, [GetReportfield,GetReport])
  useEffect(() => {
    if (GetReportfield && Array.isArray(GetReportfield)) {
      const initialData = [];
      GetReportfield.forEach(field => {
        initialData[field.formControlName] = '';
      });
      setFormData(initialData);
    }
  }, [])
const isLoading=()=>{
  return (
    loading.GetReport ||
    loading.GetReportfield ||
    loading.GetReportData
);
};


const APIChecker =()=>{
  if (callInProgress.fetchInputData && error.GetReportError) {
    const errorss = error.GetReportError;
    errorShowing(errorss);
    setCallInProgress({ ...callInProgress, fetchInputData: false });
}
if (callInProgress.fetchformFields && error.GetReportfieldError) {
  const errorss = error.GetReportfieldError;
  errorShowing(errorss);
  setCallInProgress({ ...callInProgress, fetchformFields: false });
}
if (callInProgress.fetchReportData && GetReportData) {
  if(GetReportData.length===0|| GetReportData===null){
    toast.error("No data available")
  }else{
    setReportData(GetReportData);
  }
 
 }else if (callInProgress.fetchReportData && error.GetReportDataError) {
  const errorss = error.GetReportDataError;
  errorShowing(errorss);
  setCallInProgress({ ...callInProgress, fetchReportData: false });
}
}

useEffect(()=>{
  APIChecker();
},[callInProgress,loading,error,GetReport,GetReportfield,GetReportData])

  const handleInputClick = async() => {
    setIsOpen(true);
      setReportData([])
      setCallInProgress({ ...callInProgress, fetchInputData: true });
     await dispatch(getAllReport());
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (GetReport && GetReport.length > 0) {
      const filtered = GetReport.filter((report) =>
        report.queryName.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredReports(filtered);
    }
  };

  const handleSelect = (report) => {
    setFormData({});
    setErrors({});
    setShowViewButton(true);
    setGetReportId(report.reportId);
    setSearchValue(report.queryName);
    setCallInProgress({ ...callInProgress, fetchformFields: true });
    dispatch(getReportId({ ReportId: report.reportId }))
    setIsOpen(false);
    
  
  };
  const validateForm = () => {
    const newErrors = [];
    if (formData.length === 0) {
      newErrors.general = "Please fill the mandatory fields.";
    }
    if (Array.isArray(GetReportfield)) {
      GetReportfield.forEach(field => {
        if (field.isRequired && !formData[field.formControlName]) {
          newErrors[field.formControlName] = field.errorMsg;
        }
      });
      if(searchValue.length===0){
        newErrors.general = "Please select fields.";
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  }

  const handleView = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formDataString = Object.entries(formData)
        .map(([key, value]) => `${key}:${value}`)
        .join(',');
      setCallInProgress({ ...callInProgress, fetchReportData: true });
      dispatch(getReportData({ reportId: getreportId, values: formDataString }));
    }
    setShowDownloadButton(true)
  }
  const handleDownload = () => {
    if (validateForm()) {
      // if(!GetReportData){
      //   const formDataString = Object.entries(formData)
      //     .map(([key, value]) => `${key}:${value}`)
      //     .join(',');
      //   setCallInProgress({ ...callInProgress, fetchReportData: true });
      //   dispatch(getReportData({ reportId: getreportId, values: formDataString }));
      // }
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
       }
      const excludedColumns = ['CardName', 'CardCode', 'SlpName'];
      // Step 1: Prepare the excluded data
      let excludedData = {};
      excludedColumns.forEach((col) => {
        if (reportData?.[0] && reportData[0][col] !== undefined) {
          excludedData[col] = reportData[0][col];
        }
      });
   

      // Step 2: Convert excludedData into an array format for XLSX
      const excludedRows = Object.entries(excludedData).map(([key, value]) => [key, value !== null && value !== undefined ? String(value) : '']); // Array of [column, value]
      // Step 3: Filter the headers and prepare the filtered data
      const getFilteredHeaders = (row) => {
        return row ? Object.keys(row).filter(header => !excludedColumns.includes(header)) : [];
      };
      const filteredHeaders = getFilteredHeaders(reportData?.[0] || {});  // Safe access here
      // Step 4: Transform the reportData to convert Date objects into DD-MM-YYYY format
      const filteredData = reportData?.map(row => {
        let filteredRow = {};
        filteredHeaders.forEach(header => {
          const value = row?.[header];  // Safe access with optional chaining

          if (value && typeof value === 'string' && value.includes('T')) {
            filteredRow[header] = formatDate(value); // Convert to DD-MM-YYYY if it's an ISO string
          } else {
            filteredRow[header] = value !== null ? value : ''; // For non-date fields, just use the value
          }
        });
        return filteredRow;
      }) || [];  // Default to an empty array if reportData is undefined

      // Step 5: Create the worksheet with excluded columns and filtered data
      let ws = XLSX.utils.aoa_to_sheet([]); // Create an empty sheet
      XLSX.utils.sheet_add_aoa(ws, excludedRows, { origin: { r: 0, c: 0 } });

      // Add 2 blank rows before starting the filtered headers and data
      XLSX.utils.sheet_add_aoa(ws, [[]], { origin: { r: excludedRows.length, c: 0 } });
      XLSX.utils.sheet_add_aoa(ws, [[]], { origin: { r: excludedRows.length + 1, c: 0 } });

      // Add the filtered headers and data
      XLSX.utils.sheet_add_json(ws, filteredData, { skipHeader: false, origin: { r: excludedRows.length + 2, c: 0 } });

      // Step 6: Create the workbook and export
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'LedgerStatement');

      const reportName = reportData?.[0]?.CardCode || 'Report';  // Safe access
      const fileName = `${reportName} - ledgerstatement.xlsx`;

      XLSX.writeFile(wb, fileName);
    }
    // setFormData('');
    // setErrors('');
  };
  const handleBackNav = () => {
    navigate("/DashBoard")
    setReportData([]);
    setFormData({});
  }

  return (
    <>
      <Header />
      <div className="dashBoardMain">
        <div className="dashImage"></div>
        <div className='backdiv col-12  mb-0 d-flex align-items-center'>
          <button onClick={handleBackNav} className="goBackButton">
          <ArrowBackIcon size={24}/>
          </button>
          <p className="m-0 fw-medium mx-2">LEDGER STATEMENT</p>
        </div>
        <div className="dashGradient"></div>
        {/* <div className="dashboardDiv container">
          <div className="row align-items-center mb-4">
            <div className="col-2 col-md-1">
              <button onClick={handleBackNav} className="backIcondiv btn p-0">
                <ArrowBackIcon className="Arrow-icon" /> 
              </button>
            </div>
            <div className="col-10 col-md-11 d-flex align-items-end">
              <div className="opporTitle">
                <p className="titleLedger mb-0">Ledger Statement</p>
              </div>
            </div>
          </div>
        </div> */}
        <LedgerFormFields
          formFields={GetReportfield}
          formData={formData}
          setFormData={setFormData}
          handleSelect={handleSelect}
          filteredReports={filteredReports}
          handleInputChange={handleInputChange}
          handleInputClick={handleInputClick}
          searchValue={searchValue}
          isOpen={isOpen}
          errors={errors}
          setErrors={setErrors}
          setReportData={setReportData}
        />
        <div className=' btns_div '>
        {showViewButton&&
        <Button type="submit" onClick={handleView} className='LedgerSubmit' >
        View
      </Button>
       } 
          
          {showDownloadButton && reportData?.length > 0 && (
            <Button onClick={handleDownload} type="submit" className='LedgerDownload'>Download</Button>
          )}
        </div>
      </div>
      <div className='ReportStatement-table'>
      <DynamicTable
        data={reportData}
        pageName={'Ledger'}
      />
      </div>
      <ToastContainer/>
      <Footer />
      {isLoading() &&
                <div className='loader loaderbg position-absolute '>
                    <SpinnerLoader />
                </div>
            }
    </>
  );
};

export default Reports;
